import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import {EmptyError, Observable} from 'rxjs/Rx';
import { Cart } from 'src/app/models/cart';
import { NewProduct, updateCart } from '../../models/product';
import { CookieService } from 'ngx-cookie-service';
import { stringify } from 'querystring';
import {Delivery} from 'src/app/models/cart'
import { APIConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/Rx';
@Injectable({
  providedIn: 'root'
})
export class GetCartService {

  constructor(private httpClient : HttpClient,
    private _cookie: CookieService,
    ) { }
  readonly url = APIConstants.BASE_URL
  
  getCart():Observable<any>{
    // console.log("inside the get cart")
   
    let params1 = new HttpParams().set('cartId',this._cookie.get("cartId")); 
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    let options = {headers:headers,params: params1};
    return this.httpClient.get<any>(this.url + "/cart",options) 
  }

  postCart(cartId: string,productId: string):Observable<any>{
  
  //  console.log(productId)
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    let options = {headers:headers};
    return this.httpClient.post<any>(this.url+"/cart?productId=" + productId + "&cartId=" + cartId , options);
  }

  updateCart(newProduct : updateCart,authorization: string):Observable<any>{
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': authorization
    })
    let options = {headers:headers};
    return this.httpClient.put<any>(this.url + "/cart?quantity=" + newProduct.quantity + "&cartId=" + newProduct.cartId + "&productId=" + newProduct.productId,options);
  }
  private cartItemsSource = new BehaviorSubject<number>(0);
  cartItems$ = this.cartItemsSource.asObservable();
  updateCartItems(count: number) {
    this.cartItemsSource.next(count);
  }
  quickDel(delivery:Delivery):Observable<any>{
    let cartId = this._cookie.get("cartId")
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization':this._cookie.get("Authorization")
    })
    let options = {headers:headers};
    return this.httpClient.put<any>(this.url + "/cart/fast-delivery?cartId=" + cartId + "&apply=" + delivery.fastDeliveryApplied,delivery,options);
  }

}